import { clsx } from "clsx";

import { useUser } from "@components/user-context";
import { Checkbox } from "@components/v2";
import { useOrderQueriesLoading } from "@hooks/use-order-page-loading";
import { prettyLogEvent } from "@internal/analytics";
import { Pages } from "@north-beam/nb-client-side/constants";

import { useOrderPageAdjustForReturns } from "./hooks/use-orders-filters";

export const AdjustForReturnsButton = ({
  className,
}: {
  className?: string;
}) => {
  const { user } = useUser();
  const [adjustForReturns, setAdjustForReturns] =
    useOrderPageAdjustForReturns();
  const orderQueriesLoading = useOrderQueriesLoading();

  return (
    <label className={clsx("my-auto", className)}>
      <Checkbox
        checked={adjustForReturns}
        onChange={() => {
          prettyLogEvent.onSelect({
            user,
            page: Pages.ORDERS,
            additionalActionInfo: "adjust-for-returns",
            data: {
              adjustForReturns: !adjustForReturns,
            },
          });
          setAdjustForReturns(!adjustForReturns);
        }}
        className="mr-2"
        disabled={orderQueriesLoading}
      />
      Adjust for returns
    </label>
  );
};
